import { logEvent } from "firebase/analytics";
import {analytics} from '../firebase'

/**
 * Logs API errors
 * @param {*} error specifies error 
 */
export const logApiError = (error) => {
    //log API errors
    logEvent(analytics, 'API_error', {
        api_error: error,
    });
};

/**
 * Logs exception errors
 * @param {*} error specifies error 
 */
export const logUiError = (error) => {
    //log API errors
    logEvent(analytics, 'UI_error', {
        ui_error: error,
    });
};
